import { Box, Grid } from "@mui/material";
import { Field, useDmsForm } from "../../../hooks/useDmsFrom";
import { generateYears } from "../../../utils/common";
import ControllerSelectInput from "../../../common-ui/analytics/ControllerSelectInput";
import { DatePicker } from "../../calender";
import CustomizedSwitch from "../../Switch";
import { CountMetricsChart } from "../CountMetricsChart";
import { AssetCountQuery } from "../../../services/analytics/assets";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  startFetch,
  updateAssetCountClassifier,
} from "../../../store/reducers/analytics/asset.metrics";
import { DonorSelectInput } from "../../../common-ui/select-input-models/DonorSelectInput";
import { BatchSelectInput } from "../../../common-ui/select-input-models/BatchSelectInput";

const GroupByOptions = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Asset Status",
    value: "asset_status",
  },
  {
    label: "Ownership",
    value: "ownership",
  },

  {
    label: "Asset category",
    value: "asset_category",
  },

  {
    label: "Assignment status",
    value: "assignment_status",
  },

  {
    label: "Distribution status",
    value: "distribution_status",
  },

  {
    label: "domain",
    value: "Domain",
  },
];

const YearsOptions = generateYears().map((y) => ({
  label: y.toString(),
  value: y.toString(),
}));

export const AssetCountMetricsController = () => {
  const defaultQuery = { group_by: "asset_category" };

  const { form, updateInputField, updateForm, getFormValues } =
    useDmsForm<AssetCountQuery>({
      group_by: defaultQuery.group_by,
    });

  const handleDatePicker = (date: string) => {
    updateForm((p) => ({
      ...p,
      date_received: { value: date, isValid: true },
    }));
  };

  function handleDonorSelect(item: Field) {
    updateForm((p) => ({ ...p, donor_id: item }));
  }

  function handleBatchSelect(item: Field) {
    updateForm((p) => ({ ...p, batch_id: item }));
  }

  const { classifier } = useAppSelector((d) => d.assetMetrics);

  const dispatch = useAppDispatch();
  useEffect(() => {
    const query = getFormValues();
    dispatch(startFetch());
    dispatch(updateAssetCountClassifier(query));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    form.date_received?.value,
    form.group_by?.value,
    form.is_assigned,
    form.year_received,
    form.donor_id?.value,
    form.batch_id?.value,
  ]);
  const renderController = () => {
    return (
      <Box
        sx={(theme) => ({
          [theme.breakpoints.down("lg")]: {
            width: "100%",
          },
          [theme.breakpoints.up("lg")]: {
            maxWidth: 900,
          },
        })}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
        >
          <Grid item xs={2} sm={6} md={6} lg={3}>
            <ControllerSelectInput
              width={180}
              value={form.group_by?.value ?? undefined}
              placeholder="select classifier"
              items={GroupByOptions}
              handleChange={updateInputField("group_by")}
              label="Group By"
              loading={classifier?.loading ?? true}
            />
          </Grid>
          <Grid item xs={2} sm={6} md={3} lg={3}>
            <Box width={180}>
              <DonorSelectInput
                height="small"
                placeholder="Select Donor"
                label="Donor"
                handleChange={handleDonorSelect}
                value={form.donor_id?.value}
              />
            </Box>
          </Grid>
          <Grid item xs={2} sm={6} md={3} lg={3}>
            <Box width={180}>
              <BatchSelectInput
                height="small"
                placeholder="Select Batch"
                label="Batch"
                handleChange={handleBatchSelect}
                value={form.batch_id?.value}
              />
            </Box>
          </Grid>
          <Grid item xs={2} sm={6} md={6} lg={3}>
            <Box width={180}>
              <DatePicker
                isBasic
                handleOnchange={handleDatePicker}
                label="Date Recieved"
              />
            </Box>
          </Grid>

          <Grid item xs={2} sm={6} md={6} lg={3}>
            <ControllerSelectInput
              width={180}
              label="Year"
              placeholder="Select year"
              items={YearsOptions}
              value={form.year_received?.value ?? undefined}
              handleChange={updateInputField("year_received")}
              loading={classifier?.loading ?? true}
            />
          </Grid>
          <Grid item xs={2} sm={6} md={3} lg={3}>
            <Box height={50} pt={2}>
              <CustomizedSwitch
                title="Assigned"
                onChange={updateInputField("is_assigned", "BOOLEAN")}
                value={form.is_assigned?.value ?? false}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const refresh = () => {
    const query = getFormValues();
    dispatch(startFetch());
    dispatch(updateAssetCountClassifier(query));
  };
  const reset = () => {
    dispatch(startFetch());
    updateForm({ group_by: { value: defaultQuery.group_by } });
    dispatch(updateAssetCountClassifier(defaultQuery));
  };
  return (
    <CountMetricsChart
      title="Assets Analytics"
      refresh={refresh}
      reset={reset}
      data={classifier?.data ?? {}}
      loading={classifier?.loading ?? true}
      controller={renderController()}
    />
  );
};
